import { LiquidButton } from '@/components/LiquidButton';
import { useRecipeGrid } from '@/components/RecipeGrid/RecipeGridProvider';
import { COLORS } from '@/styles/constants';

type Props = {
  loadMoreLabel?: string;
};

export const RecipeGridNavigation = ({ loadMoreLabel }: Props) => {
  const { state, dispatch } = useRecipeGrid();

  const nextButtonDisabled = state.page === state.totalPages - 1 || state.loading;

  const allLoaded = state.recipes.length >= state.totalResults;

  if (state.totalPages <= 1 || allLoaded) {
    return null;
  }

  return (
    <div className="w-full flex items-center flex-row justify-center mt-5">
      <button onClick={() => dispatch({ type: 'SET_PAGE', page: state.page + 1 })}>
        <LiquidButton
          text={loadMoreLabel || 'Load More'}
          height={50}
          width={190}
          color={nextButtonDisabled ? COLORS.secondary : COLORS.primary}
          textColor={COLORS.white}
          disabled={nextButtonDisabled}
        />
      </button>
    </div>
  );
};
